// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const ninjask: PokeData = {
  "id": 291,
  "name": "ninjask",
  "height": 8,
  "weight": 120,
  "base_experience": 160,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "scratch",
    "swords-dance",
    "sand-attack",
    "absorb",
    "dig",
    "agility",
    "screech",
    "double-team",
    "harden",
    "leech-life",
    "fury-swipes",
    "slash",
    "mind-reader",
    "mud-slap",
    "false-swipe",
    "fury-cutter",
    "baton-pass",
    "metal-claw",
    "aerial-ace",
    "x-scissor",
    "bug-bite"
  ],
  "moves": [
    "scratch",
    "mud-slap",
    "metal-claw",
    "aerial-ace",
    "bug-bite",
    "tailwind",
    "bug-buzz",
    "peck",
    "signal-spam",
    "air-slash",
    "hurricane",
    "roost",
    "lunge"
  ],
  "evolution_chain": {
    "id": 144,
    "item": null,
    "species": [
      {
        "name": "nincada",
        "order": 316,
        "types": [
          PokeType.BUG,
          PokeType.GROUND
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "ninjask",
        "order": 317,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 290,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "shedinja",
        "order": 318,
        "types": [
          PokeType.BUG,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 290,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.SHED
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 71,
    "speed": 210,
    "ability_power": 118
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
